import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

import { LoadingIndicatorSpinner } from '@storebrand-digital/pretzel';

interface Props extends ComponentPropsWithoutRef<
  typeof LoadingIndicatorSpinner
> {
  hasOverlay?: boolean;
  isFixed?: boolean;
}

export const CenteredLoadingIndicator = ({
  hasOverlay,
  isFixed,
  ...props
}: Props) => {
  return (
    <div
      className={clsx(
        'grid place-items-center w-full h-full',
        isFixed ? 'fixed left-0 top-0' : 'relative',
        hasOverlay ? 'bg-[rgba(255,255,255,0.8)]' : 'pointer-events-none',
      )}
    >
      <LoadingIndicatorSpinner {...props} />
    </div>
  );
};
